import {Injectable} from '@angular/core';
import {
  LINGUE,
  LOCALE_TYPE, Torneo, Utente,
} from '../../core/@types';
import {DeviceInfo} from '@capacitor/device';
import {Capacitor} from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {
  }

  static getLangString(lingua: LINGUE): LOCALE_TYPE {
    switch (lingua) {
      default:
      case 'Italiano':
        return 'it';
      case 'Inglese':
        return 'en';
    }
  }

  static compareVersion(a, b) {
    const regExStrip0 = /(\.0+)+$/;
    const segmentsA = a.replace(regExStrip0, '').split('.');
    const segmentsB = b.replace(regExStrip0, '').split('.');
    const l = Math.min(segmentsA.length, segmentsB.length);

    for (let i = 0; i < l; i++) {
      const diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
      if (diff) {
        return diff;
      }
    }

    return segmentsA.length - segmentsB.length;
  }

  static isNewerVersion(oldVer, newVer) {
    const oldParts = oldVer.split('.');
    const newParts = newVer.split('.');
    for (let i = 0; i < newParts.length; i++) {
      const a = Number.parseInt(newParts[i], 10);
      const b = Number.parseInt(oldParts[i], 10);
      if (a > b) {
        return true;
      }
      if (a < b) {
        return false;
      }
    }
    return false;
  }

  static normalizeUtente(utente: Utente): Utente {
    return {
      ...utente,
      id: Number(utente.id)
    };
  }

  static normalizeTorneo(torneo: Torneo): Torneo {
    return {
      ...torneo,
      id: Number(torneo.id),
      Righe: torneo.Righe.map(riga => ({
        id: Number(riga.id),
        IDTorneo: Number(riga.IDTorneo),
        IDUtente: Number(riga.IDUtente),
        Punteggio: (!riga.Punteggio || riga?.Punteggio == 0) ? undefined : Number(riga?.Punteggio),
        Posizionamento: (!riga.Posizionamento || riga?.Posizionamento == 0) ? undefined : Number(riga?.Posizionamento)
      }))
    };
  }

  static convertBlobToBase64 = async (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });


  static getOsVersion(deviceInfo: DeviceInfo): string {

    if (!Capacitor.isNativePlatform) {
      return 'No device';
    }

    if (Capacitor.getPlatform() === 'ios') {
      return 'Ios ' + deviceInfo.osVersion + ' - v. ' + deviceInfo.iOSVersion.toString().match(/.{1,2}/g).map(x => Number(x)).toString().replace(/,/g, '.');
    } else {
      return 'Android ' + deviceInfo.osVersion + ' - SDK: ' + deviceInfo.androidSDKVersion;
    }

  }

  // Auto focus e selezione del campi di input
  static autoFocusAlertInput(inputName: string, autoSelect: boolean = true) {
    setTimeout(() => {
      const inputElement: HTMLInputElement = document.querySelector(`ion-alert input[name="${inputName}"]`);
      if (inputElement) {
        inputElement.focus();
        if (autoSelect) {
          inputElement.select();
        }
      }
    }, 100);
  }

  // Auto focus e selezione del campi di input
  static autoFocusInput(inputName: string, autoSelect: boolean = true) {
    setTimeout(() => {
      const inputElement: HTMLInputElement = document.querySelector(`input[name="${inputName}"]`);
      if (inputElement) {
        inputElement.focus();
        if (autoSelect) {
          inputElement.select();
        }
      }
    }, 100);
  }

}
